module.exports = __webpack_public_path__ + "static/media/Werner Ave Daly City, CA (3 Houses)2.25f88ef6.jpg";